import React from 'react';

import * as s from './RubricButton.css';

export interface IRubricLink {
  children: React.ReactText;
  url: string;
  onClick(e: React.MouseEvent): void;
}

/**
 * Кнопка рубрики
 */
export const RubricButton = ({ children, url, onClick }: IRubricLink) => {
  return (
    <a href={url} className={s['wrapper']} onClick={onClick}>
      {children}
    </a>
  );
};
